var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThankYouFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1715_11769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.25 0C14.4253 0 0 14.4239 0 32.25C0 50.0748 14.4239 64.5 32.25 64.5C50.0747 64.5 64.5 50.0761 64.5 32.25C64.5 14.4252 50.0761 0 32.25 0ZM32.25 59.4609C17.2104 59.4609 5.03906 47.2907 5.03906 32.25C5.03906 17.2103 17.2093 5.03906 32.25 5.03906C47.2896 5.03906 59.4609 17.2093 59.4609 32.25C59.4609 47.2897 47.2907 59.4609 32.25 59.4609Z",
    fill: "url(#paint0_linear_1715_11769)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2841 39.721L35.8135 32.2503L43.2841 24.7796C44.268 23.7958 44.2682 22.2005 43.2843 21.2165C42.3001 20.2325 40.7049 20.2326 39.7212 21.2165L32.2504 28.6872L24.7796 21.2165C23.7958 20.2325 22.2003 20.2325 21.2165 21.2165C20.2326 22.2005 20.2326 23.7958 21.2166 24.7796L28.6872 32.2503L21.2166 39.721C20.2326 40.705 20.2325 42.3002 21.2165 43.2841C22.2007 44.2682 23.796 44.2678 24.7796 43.2841L32.2504 35.8134L39.7212 43.2841C40.7048 44.268 42.3003 44.2681 43.2843 43.2841C44.2683 42.3001 44.2682 40.7048 43.2841 39.721Z",
    fill: "url(#paint1_linear_1715_11769)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1715_11769",
    x1: 32.25,
    y1: 0,
    x2: 32.25,
    y2: 64.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1715_11769",
    x1: 32.2504,
    y1: 20.4785,
    x2: 32.2504,
    y2: 44.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9696"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1715_11769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.5,
    height: 64.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYouFailed);
export default __webpack_public_path__ + "static/media/ThankYouFailed.c21abf9d09bd228e9e44113f360d1cf2.svg";
export { ForwardRef as ReactComponent };